import { Card } from "semantic-ui-react";
import { NewPageComponent } from "../components/page/NewPageComponent";
import { getEventMetadata, getSession } from "../helper";
import {
  LIST_WAITING_FORS,
  NEW_LIST_FILTERED_ELEMENTS,
} from "../routes/queries";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import {
  CREATE_NEW_ELEMENT,
  NEW_DELETE_ELEMENT,
  NEW_UPDATE_ELEMENT,
} from "../routes/mutations";
import { getNewWaitingForFormFields } from "./waiting_for_form";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";
import { LinkedReferenceLibraryElementsSection } from "src/referencelibrary/ReferenceLibraryElementSection";

const WaitingForCard = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid key={props.data.id}>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <Card.Header style={{ fontSize: 18 }}>
            <b>{props.data.name}</b>
          </Card.Header>
          <CardDotMenuComponent
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
            cardData={props.data}
            props={{
              menuItems: [
                {
                  type: "api_call",
                  label: "Delete",
                  apiCall: NEW_DELETE_ELEMENT,
                  callback: (
                    data: any,
                    setReloadKey: any,
                    pageData: any,
                    setPageData: any,
                  ) => {
                    setReloadKey((key: number) => key + 1);
                  },
                  apiCallVariables: (data: any) => {
                    return {
                      id: props.data.id,
                      session: getSession(),
                      isChildElement: true,
                      eventMetadata: getEventMetadata(),
                    };
                  },
                  showMenuOption: (data: any) => {
                    return true;
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Edit",
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: getNewWaitingForFormFields(),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                      lifeDomainId: props.data.lifeDomain?.id,
                      parentElementId: props.data.parentElement?.id,
                      id: props.data.id,
                      personId: props.data.person?.id,
                      organizationId: props.data.organization?.id,
                      blocksIds:
                        props.data.blocks.map((block: any) => block.id) || [],
                      blockedByIds:
                        props.data.blockedBy.map(
                          (blockedBy: any) => blockedBy.id,
                        ) || [],
                    },
                  }),
                  modalHeader: "Edit Waiting For",
                  apiCall: NEW_UPDATE_ELEMENT,
                  callback: (data: any) => {
                    props.setReloadKey((key: number) => key + 1);
                  },
                  showMenuOption: (data: any) => {
                    return true;
                  },
                },
              ],
            }}
          />
        </div>
      </Card.Content>
      <Card.Content>
        {props.data.lifeDomain && (
          <div className="life-domain-name">
            <b>Life Domain: </b>
            {props.data.lifeDomain!.name}
          </div>
        )}
        {props.data.parentElement && (
          <div className="project-name" id="project-name">
            <b>Project: </b>
            {props.data.parentElement!.name}
          </div>
        )}
        {props.data.organization && (
          <div className="organization-name">
            <b>Organization: </b>
            {props.data.organization!.name}
          </div>
        )}
        {props.data.person && (
          <div className="person-name">
            <b>Person: </b>
            {props.data.person!.name}
          </div>
        )}
        {props.data.blocks && props.data.blocks.length > 0 && (
          <div className="blocks">
            <b>Blocks: </b>
            {props.data.blocks.map((block: any) => block.name).join(", ")}
          </div>
        )}
        {props.data.blockedBy && props.data.blockedBy.length > 0 && (
          <div className="blocked-bys">
            <b>Blocked By: </b>
            {props.data.blockedBy
              .map((blockedBy: any) => blockedBy.name)
              .join(", ")}
          </div>
        )}
      </Card.Content>
      <LinkedReferenceLibraryElementsSection
        data={props.data}
        setReloadKey={props.setReloadKey}
      />
    </Card>
  );
};

export const NewWaitingForPage = () => {
  return (
    <NewPageComponent
      props={{
        type: "list_page",
        query: {
          documentNode: LIST_WAITING_FORS,
          key: "listWaitingFors",
        },
        queryVariables: {
          session: getSession(),
        },
        itemName: "Waiting For",
        card: WaitingForCard,
        creationProps: {
          formComponentProps: new NewNewFormComponentProps({
            form: {
              formFields: getNewWaitingForFormFields(),
              type: "single_form",
            },
            startingData: {
              name: "",
              organizationId: undefined,
            },
          }),
          apiCall: CREATE_NEW_ELEMENT,
        },
      }}
    />
  );
};
